import React from "react";

/**
 * Radio button.
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.name
 */
export function Radio({ label, ...rest }) {
  return (
    <label className="ds-radio">
      <input type="radio" {...rest} />
      {label}
    </label>
  );
}
